const WhatsApp = () => {
  return <img src="/wa/PMUCYAJUT2KEF1.png" width="250" />;
};

export default WhatsApp;
